import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

import heroImg from '../../assets/img/hero/hero-5-1.png';
import discountImg from '../../assets/img/hero/discount.png';

const Hero = () => {
  return (
    <div className="it-hero-5-area it-hero-5-ptb fix p-relative z-index grey-bg-2">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xxl-8 col-xl-6 col-lg-6">
            <div className="it-hero-5-content">
              <h1
                className="it-hero-title pb-5 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                Your prescription for affordable health solutions!
              </h1>
              <div
                className="it-hero-5-text mb-40 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et <br /> dolore magna
                  aliqua. Ut enim ad minim veniam, quis nostrud exercitation .
                </p>
              </div>
              <div
                className="it-hero-button-wrapper wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <div className="it-hero-button">
                  <Link className="it-btn-theme" to="/cart">
                    <Button btnText="Shop Now" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-4 col-xl-6 col-lg-6">
            <div className="it-hero-5-thumb-right text-lg-start text-center p-relative">
              <div className="it-hero-5-thumb">
                <img src={heroImg} alt="" />
              </div>
              <div className="it-hero-5-discount">
                <img src={discountImg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
